import { render, staticRenderFns } from "./AddBankAccount.vue?vue&type=template&id=0f0b86ce&"
import script from "./AddBankAccount.vue?vue&type=script&lang=ts&"
export * from "./AddBankAccount.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports